import TemplateCategories from "components/Templates/templateCategories"
import React, { useContext, useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { useParams } from "react-router-dom"
import { Container } from "reactstrap"
import TemplatesContext from "context/templates/templatesContext"
import AuthContext from "context/auth/authContext"

const TemplatePage = () => {
  const { templateId } = useParams()
  const { getTemplate } = useContext(TemplatesContext)
  const { user, getUser } = useContext(AuthContext)
  useEffect(() => {
    getTemplate(templateId)
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Plantillas </title>
        </Helmet>
        <Container fluid>
          <TemplateCategories />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TemplatePage
